/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Shop_Drag_AriaInputs */

const vi_shop_drag_aria = /** @type {(inputs: Shop_Drag_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kéo để đổi thứ tự ${i?.name}`)
};

/**

* @param {Shop_Drag_AriaInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_drag_aria = /** @type {((inputs: Shop_Drag_AriaInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Drag_AriaInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_drag_aria(inputs)
});